import {Injectable} from '@angular/core';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {SERVER_API_URL} from '../../app.constants';
import {createRequestOption} from '../../shared/util/request-util';
import {IProjectItems} from "../../shared/model/project-items.model";


type EntityResponseType = HttpResponse<IProjectItems>;
type EntityArrayResponseType = HttpResponse<IProjectItems[]>;

@Injectable({providedIn: 'root'})
export class ProjectItemsService {
  public resourceUrl = SERVER_API_URL + 'api/project-items';
  public resourceUrlValidation = SERVER_API_URL + 'api/project-items-validation';

  constructor(protected http: HttpClient) {
  }

  createLoadCoding(project: IProjectItems): Observable<EntityResponseType> {
    return this.http.post<IProjectItems>(this.resourceUrl+'-coding-step', project, {observe: 'response'});
  }
  create(project: IProjectItems): Observable<EntityResponseType> {
    return this.http.post<IProjectItems>(this.resourceUrl, project, {observe: 'response'});
  }

  update(project: IProjectItems): Observable<EntityResponseType> {
    return this.http.put<IProjectItems>(this.resourceUrl, project, {observe: 'response'});
  }
  reform(project: IProjectItems): Observable<EntityResponseType> {
    return this.http.put<IProjectItems>(this.resourceUrl+'-reform', project, {observe: 'response'});
  }

  find(id: number): Observable<EntityResponseType> {
    return this.http.get<IProjectItems>(`${this.resourceUrl}/${id}`, {observe: 'response'});
  }

  createValidationNumber(phone: IProjectItems): Observable<EntityResponseType> {
    return this.http.post<IProjectItems>(this.resourceUrlValidation, phone, {observe: 'response'});
  }

  createValidationDuplicateTitle(phone: IProjectItems): Observable<EntityResponseType> {
    return this.http.post<IProjectItems>(this.resourceUrl+'-duplicate-title-validation', phone, {observe: 'response'});
  }

  findProjectCount(): Observable<HttpResponse<any>> {
    return this.http
      .get<any>(`${this.resourceUrl + '-all-count'}`, {observe: 'response'});
  }

  findProjectMonthly(param:any,stepParam:any): Observable<HttpResponse<any>> {
    return this.http
      .get<IProjectItems>(`${this.resourceUrl + '-monthly/'+param+'/'+stepParam}`, {observe: 'response'});
  }
  query(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IProjectItems[]>(this.resourceUrl, {params: options, observe: 'response'});
  }
  searchReport(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IProjectItems[]>(this.resourceUrl+'-search-report', {params: options, observe: 'response'});
  }

  findWithCustomerId(req?: any, id?:any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IProjectItems[]>(this.resourceUrl + '-customer/'+id, {params: options, observe: 'response'});
  }
  findWithProjectId(req?: any, id?:any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IProjectItems[]>(this.resourceUrl + '-project/'+id, {params: options, observe: 'response'});
  }
  findAllProjectItemsForCalnedar(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IProjectItems[]>(this.resourceUrl + '-part-all', {params: options, observe: 'response'});
  }

  getProjectItemsWithStep(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IProjectItems[]>(this.resourceUrl + '-part', {params: options, observe: 'response'});
  }


  getListProjectItemsByPartByFilter(step?: any): Observable<EntityArrayResponseType> {
    // const options = createRequestOption(req);
    return this.http.get<IProjectItems[]>(this.resourceUrl + '-part/'+step, {params: null, observe: 'response'});
  }

  getListProjectItemsByPartByFilterTitle(title?: any): Observable<EntityArrayResponseType> {
    // const options = createRequestOption(req);
    return this.http.get<IProjectItems[]>(this.resourceUrl + '-part-str/'+title, {params: null, observe: 'response'});
  }

  getListProjectItemsGroupByTitle(): Observable<EntityArrayResponseType> {
    // const options = createRequestOption(req);
    return this.http.get<IProjectItems[]>(this.resourceUrl + '-group-by', {params: null, observe: 'response'});
  }

  // getListProjectItemsByPartByFilter(step?:any,req?: any): Observable<EntityArrayResponseType> {
  //   const options = createRequestOption(req);
  //   return this.http.get<IProjectItems[]>(this.resourceUrl + '-part/'+step, {params: options, observe: 'response'});
  // }

  searchReportByTypeDaily(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IProjectItems[]>(this.resourceUrl + '-search-report-last', {params: options, observe: 'response'});
  }

  searchReportByTypeDailyStatus(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IProjectItems[]>(this.resourceUrl + '-search-report-last-status', {params: options, observe: 'response'});
  }

  searchDailyWithDetail(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IProjectItems[]>(this.resourceUrl + '-search-report-last-daily', {params: options, observe: 'response'});
  }

  searchDailyWithDetailAndStatus(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IProjectItems[]>(this.resourceUrl + '-search-report-last-status-daily', {params: options, observe: 'response'});
  }

  // findByStatus(req?: any, status?:any): Observable<EntityArrayResponseType> {
  //   const options = createRequestOption(req);
  //   return this.http.get<IProjectItems[]>(this.resourceUrl + '-list-status/'+status, {params: options, observe: 'response'});
  // }

  findByStatus(req?: any, status?:any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IProjectItems[]>(this.resourceUrl+'-list-status/'+status, {params: options, observe: 'response'});
  }

  findProjectNoFollowUpCount(): Observable<HttpResponse<any>> {
    return this.http
      .get<any>(`${this.resourceUrl + '-noFollowUp-count'}`, {  observe: 'response' });
  }


  checkFOrArchive(id?:any): Observable<EntityArrayResponseType> {
    // const options = createRequestOption(req);
    return this.http.get<IProjectItems[]>(this.resourceUrl+'-check-archive/'+id, {params: null, observe: 'response'});
  }

  delete(id: number): Observable<HttpResponse<any>> {
    return this.http.delete<any>(`${this.resourceUrl}/${id}`, {observe: 'response'});
  }


  querySendNotify(req?: any): Observable<HttpResponse<IProjectItems[]>> {
    const options = createRequestOption(req);

    return this.http.get<any>(this.resourceUrl+'-send-notify', { params: options, observe: 'response' });
  }
}
